import { PaymentIntervalEnum } from '@omnea-app/packages/universal/hasura/graphql'
import { assertNever } from '@omnea-app/packages/universal/type-guards/assertNever'
import { Nullish } from '@omnea-app/packages/universal/utility-types/utilityTypes'

export const getAnnualPriceValue = (
  value: number,
  paymentInterval: Nullish<PaymentIntervalEnum>,
  multiYears: number | null
): number => {
  return value * getPaymentIntervalMultiplier(paymentInterval, multiYears)
}

export const getPaymentIntervalMultiplier = (
  paymentInterval: Nullish<PaymentIntervalEnum>,
  multiYears: number | null
): number => {
  switch (paymentInterval) {
    case PaymentIntervalEnum.WEEK:
      return 52.1429
    case PaymentIntervalEnum.MONTH:
      return 12
    case PaymentIntervalEnum.QUARTER:
      return 4
    case PaymentIntervalEnum.EVERY_SIX_MONTHS:
      return 2
    case PaymentIntervalEnum.MULTI_YEAR:
      if (multiYears) {
        return 1 / multiYears
      }
      return 1
    case PaymentIntervalEnum.EVERY_TWO_YEARS:
      return 0.5
    case PaymentIntervalEnum.ONE_OFF:
    case PaymentIntervalEnum.YEAR:
    case undefined:
    case null:
      return 1
    default:
      assertNever(paymentInterval)
      return 1
  }
}
